$(document).ready(function () {
  $('.js-nav-list').affix({
    offset: {
      top: 120,
      bottom: 520,
    }
  });
});
